// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Sidebar styles
 * Uses design tokens defined in the global styles.scss.
 * Scoped to #sidebar to avoid affecting links and icons elsewhere.
 */
#sidebar {
  --sidebar-width: 250px;
  --sidebar-content-gap: 0.3125rem;
  --sidebar-item-radius: var(--ca-radius-sm, 6px);
  --sidebar-item-padding-block: 0.625rem;
  --sidebar-item-padding-inline: 0.75rem;
  display: flex;
  flex-direction: column;
  width: var(--sidebar-width);
  height: 100%;
  min-height: 0;
  flex: 0 0 var(--sidebar-width);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  background: var(--ca-sidebar-bg, #07112e);
  color: var(--ca-text-on-dark, #ffffff);
  border-right: 1px solid var(--ca-sidebar-border, rgba(255, 255, 255, 0.08));
}
#sidebar #title {
  flex: 0 0 auto;
  margin: 0;
  padding: 2rem 1rem 1.25rem;
  color: var(--ca-sidebar-title, #e4e9f2);
  font-size: 1.05rem;
  font-weight: 650;
  line-height: 1.35;
  letter-spacing: 0.01em;
  text-align: center;
  overflow-wrap: anywhere;
}
#sidebar .menu {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--sidebar-content-gap);
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0.5rem 0.625rem 1rem;
  font-size: 0.875rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(220, 229, 245, 0.28) transparent;
}
#sidebar .menu::-webkit-scrollbar {
  width: 6px;
}
#sidebar .menu::-webkit-scrollbar-track {
  background: transparent;
}
#sidebar .menu::-webkit-scrollbar-thumb {
  background: rgba(220, 229, 245, 0.28);
  border-radius: 999px;
}
#sidebar .menu > a,
#sidebar .menu .dropdown-parent {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  padding: var(--sidebar-item-padding-block) var(--sidebar-item-padding-inline);
  border: 1px solid transparent;
  border-radius: var(--sidebar-item-radius);
  color: var(--ca-sidebar-text, #dce5f5);
  background: transparent;
  font: inherit;
  line-height: 1.35;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
  -webkit-tap-highlight-color: transparent;
}
#sidebar .menu > a:hover,
#sidebar .menu .dropdown-parent:hover {
  color: #ffffff;
  background: var(--ca-sidebar-hover, rgba(40, 80, 173, 0.2));
}
#sidebar .menu > a:focus-visible,
#sidebar .menu .dropdown-parent:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}
#sidebar .menu > a.active,
#sidebar .menu .dropdown-parent.active {
  color: #ffffff;
  background: var(--ca-sidebar-active, #0d2863);
  border-color: rgba(255, 255, 255, 0.08);
  font-weight: 600;
}
#sidebar .menu > a .entry,
#sidebar .menu .dropdown-parent .entry {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  min-width: 0;
  padding: 0;
}
#sidebar .menu > a .entry > span,
#sidebar .menu .dropdown-parent .entry > span {
  min-width: 0;
  overflow-wrap: anywhere;
}
#sidebar .menu > a i.bi,
#sidebar .menu .dropdown-parent i.bi {
  display: inline-flex;
  flex: 0 0 1.25rem;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: var(--ca-sidebar-icon, #7896df);
  font-size: 1.05rem;
  line-height: 1;
  transition: color 150ms ease;
}
#sidebar .menu > a:hover i.bi, #sidebar .menu > a.active i.bi,
#sidebar .menu .dropdown-parent:hover i.bi,
#sidebar .menu .dropdown-parent.active i.bi {
  color: #ffffff;
}
#sidebar .dropdown-wrapper {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}
#sidebar .dropdown-parent {
  justify-content: flex-start;
}
#sidebar .dropdown-parent .entry > i:last-child {
  flex: 0 0 auto;
  margin-left: auto;
  font-size: 0.75rem;
}
#sidebar .submenu {
  display: none;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0.125rem 0 0.375rem 1rem;
  padding: 0.25rem 0 0.25rem 0.625rem;
  border-left: 1px solid rgba(255, 255, 255, 0.16);
}
#sidebar .submenu.open {
  display: flex;
}
#sidebar .submenu a {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 0.5rem 0.625rem;
  border: 1px solid transparent;
  border-radius: var(--sidebar-item-radius);
  color: var(--ca-sidebar-text, #dce5f5);
  background: transparent;
  font-size: 0.8125rem;
  line-height: 1.35;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}
#sidebar .submenu a:hover {
  color: #ffffff;
  background: var(--ca-sidebar-hover, rgba(40, 80, 173, 0.2));
}
#sidebar .submenu a:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}
#sidebar .submenu a.active {
  color: #ffffff;
  background: var(--ca-sidebar-active, #0d2863);
  border-color: rgba(255, 255, 255, 0.08);
  font-weight: 600;
}
#sidebar .submenu a .entry {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  min-width: 0;
  padding: 0;
}
#sidebar .submenu a .entry > span {
  min-width: 0;
  overflow-wrap: anywhere;
}
#sidebar .submenu a i.bi {
  display: inline-flex;
  flex: 0 0 1rem;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: var(--ca-sidebar-icon, #7896df);
  font-size: 0.9rem;
}
#sidebar .submenu a:hover i.bi, #sidebar .submenu a.active i.bi {
  color: #ffffff;
}
#sidebar .submenu-entry {
  padding-left: 0;
}
#sidebar #options {
  flex: 0 0 auto;
  gap: 0.25rem;
  margin-top: auto;
  padding: 0.75rem 0.625rem 1rem;
  border-top: 1px solid var(--ca-sidebar-border, rgba(255, 255, 255, 0.08));
  background: var(--ca-sidebar-bg, #07112e);
}
#sidebar #options > a {
  min-height: 38px;
}

/* Keep the sidebar usable on shorter viewports. */
@media (max-height: 600px) {
  #sidebar #title {
    padding-top: 1rem;
    padding-bottom: 0.75rem;
  }
  #sidebar .menu {
    padding-top: 0.25rem;
    padding-bottom: 0.5rem;
  }
  #sidebar #options {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  #sidebar,
  #sidebar * {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/navigation/side-navbar/side-navbar.component.scss"],"names":[],"mappings":"AAAA;;;;EAAA;AAMA;EACE,sBAAA;EACA,gCAAA;EACA,+CAAA;EACA,sCAAA;EACA,sCAAA;EAEA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,sCAAA;EACA,2EAAA;AADF;AAGE;EACE,cAAA;EACA,SAAA;EACA,0BAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;EACA,sDAAA;AAFJ;AAII;EACE,UAAA;AAFN;AAKI;EACE,uBAAA;AAHN;AAMI;EACE,qCAAA;EACA,oBAAA;AAJN;AAOI;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,6EAAA;EAEA,6BAAA;EACA,yCAAA;EACA,sCAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kFACE;EAGF,wCAAA;AATN;AAWM;;EACE,cAAA;EACA,2DAAA;AARR;AAWM;;EACE,mDAAA;EACA,mBAAA;AARR;AAWM;;EACE,cAAA;EACA,6CAAA;EACA,uCAAA;EACA,gBAAA;AARR;AAWM;;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AARR;AAWM;;EACE,YAAA;EACA,uBAAA;AARR;AAWM;;EACE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,4BAAA;AARR;AAWM;;;EAEE,cAAA;AARR;AAaE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAXJ;AAcE;EACE,2BAAA;AAZJ;AAcI;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAZN;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,mCAAA;EACA,gDAAA;AAdJ;AAgBI;EACE,aAAA;AAdN;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;EACA,yCAAA;EACA,sCAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,kFACE;AAhBR;AAoBM;EACE,cAAA;EACA,2DAAA;AAlBR;AAqBM;EACE,mDAAA;EACA,mBAAA;AAnBR;AAsBM;EACE,cAAA;EACA,6CAAA;EACA,uCAAA;EACA,gBAAA;AApBR;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AArBR;AAwBM;EACE,YAAA;EACA,uBAAA;AAtBR;AAyBM;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;EACA,iBAAA;AAvBR;AA0BM;EAEE,cAAA;AAzBR;AA8BE;EACE,eAAA;AA5BJ;AA+BE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,yEAAA;EACA,yCAAA;AA7BJ;AA+BI;EACE,gBAAA;AA7BN;;AAkCA,kDAAA;AACA;EAEI;IACE,iBAAA;IACA,uBAAA;EAhCJ;EAmCE;IACE,oBAAA;IACA,sBAAA;EAjCJ;EAoCE;IACE,mBAAA;IACA,sBAAA;EAlCJ;AACF;AAsCA;EACE;;IAEE,gCAAA;IACA,sCAAA;IACA,qCAAA;IACA,uCAAA;EApCF;AACF","sourcesContent":["/*\r\n * Sidebar styles\r\n * Uses design tokens defined in the global styles.scss.\r\n * Scoped to #sidebar to avoid affecting links and icons elsewhere.\r\n */\r\n\r\n#sidebar {\r\n  --sidebar-width: 250px;\r\n  --sidebar-content-gap: 0.3125rem;\r\n  --sidebar-item-radius: var(--ca-radius-sm, 6px);\r\n  --sidebar-item-padding-block: 0.625rem;\r\n  --sidebar-item-padding-inline: 0.75rem;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: var(--sidebar-width);\r\n  height: 100%;\r\n  min-height: 0;\r\n  flex: 0 0 var(--sidebar-width);\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  overflow: hidden;\r\n  background: var(--ca-sidebar-bg, #07112e);\r\n  color: var(--ca-text-on-dark, #ffffff);\r\n  border-right: 1px solid var(--ca-sidebar-border, rgba(255, 255, 255, 0.08));\r\n\r\n  #title {\r\n    flex: 0 0 auto;\r\n    margin: 0;\r\n    padding: 2rem 1rem 1.25rem;\r\n    color: var(--ca-sidebar-title, #e4e9f2);\r\n    font-size: 1.05rem;\r\n    font-weight: 650;\r\n    line-height: 1.35;\r\n    letter-spacing: 0.01em;\r\n    text-align: center;\r\n    overflow-wrap: anywhere;\r\n  }\r\n\r\n  .menu {\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    flex-direction: column;\r\n    gap: var(--sidebar-content-gap);\r\n    min-height: 0;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    padding: 0.5rem 0.625rem 1rem;\r\n    font-size: 0.875rem;\r\n    scrollbar-width: thin;\r\n    scrollbar-color: rgba(220, 229, 245, 0.28) transparent;\r\n\r\n    &::-webkit-scrollbar {\r\n      width: 6px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: transparent;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: rgba(220, 229, 245, 0.28);\r\n      border-radius: 999px;\r\n    }\r\n\r\n    > a,\r\n    .dropdown-parent {\r\n      display: flex;\r\n      align-items: center;\r\n      width: 100%;\r\n      min-height: 40px;\r\n      box-sizing: border-box;\r\n      padding: var(--sidebar-item-padding-block)\r\n        var(--sidebar-item-padding-inline);\r\n      border: 1px solid transparent;\r\n      border-radius: var(--sidebar-item-radius);\r\n      color: var(--ca-sidebar-text, #dce5f5);\r\n      background: transparent;\r\n      font: inherit;\r\n      line-height: 1.35;\r\n      text-align: left;\r\n      text-decoration: none;\r\n      cursor: pointer;\r\n      transition:\r\n        background-color 150ms ease,\r\n        color 150ms ease,\r\n        border-color 150ms ease;\r\n      -webkit-tap-highlight-color: transparent;\r\n\r\n      &:hover {\r\n        color: #ffffff;\r\n        background: var(--ca-sidebar-hover, rgba(40, 80, 173, 0.2));\r\n      }\r\n\r\n      &:focus-visible {\r\n        outline: 2px solid var(--ca-primary-light, #2850ad);\r\n        outline-offset: 2px;\r\n      }\r\n\r\n      &.active {\r\n        color: #ffffff;\r\n        background: var(--ca-sidebar-active, #0d2863);\r\n        border-color: rgba(255, 255, 255, 0.08);\r\n        font-weight: 600;\r\n      }\r\n\r\n      .entry {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.75rem;\r\n        width: 100%;\r\n        min-width: 0;\r\n        padding: 0;\r\n      }\r\n\r\n      .entry > span {\r\n        min-width: 0;\r\n        overflow-wrap: anywhere;\r\n      }\r\n\r\n      i.bi {\r\n        display: inline-flex;\r\n        flex: 0 0 1.25rem;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin: 0;\r\n        color: var(--ca-sidebar-icon, #7896df);\r\n        font-size: 1.05rem;\r\n        line-height: 1;\r\n        transition: color 150ms ease;\r\n      }\r\n\r\n      &:hover i.bi,\r\n      &.active i.bi {\r\n        color: #ffffff;\r\n      }\r\n    }\r\n  }\r\n\r\n  .dropdown-wrapper {\r\n    display: flex;\r\n    flex: 0 0 auto;\r\n    flex-direction: column;\r\n    gap: 0.25rem;\r\n    min-width: 0;\r\n  }\r\n\r\n  .dropdown-parent {\r\n    justify-content: flex-start;\r\n\r\n    .entry > i:last-child {\r\n      flex: 0 0 auto;\r\n      margin-left: auto;\r\n      font-size: 0.75rem;\r\n    }\r\n  }\r\n\r\n  .submenu {\r\n    display: none;\r\n    flex-direction: column;\r\n    gap: 0.25rem;\r\n    margin: 0.125rem 0 0.375rem 1rem;\r\n    padding: 0.25rem 0 0.25rem 0.625rem;\r\n    border-left: 1px solid rgba(255, 255, 255, 0.16);\r\n\r\n    &.open {\r\n      display: flex;\r\n    }\r\n\r\n    a {\r\n      display: flex;\r\n      align-items: center;\r\n      min-height: 36px;\r\n      padding: 0.5rem 0.625rem;\r\n      border: 1px solid transparent;\r\n      border-radius: var(--sidebar-item-radius);\r\n      color: var(--ca-sidebar-text, #dce5f5);\r\n      background: transparent;\r\n      font-size: 0.8125rem;\r\n      line-height: 1.35;\r\n      text-decoration: none;\r\n      cursor: pointer;\r\n      transition:\r\n        background-color 150ms ease,\r\n        color 150ms ease,\r\n        border-color 150ms ease;\r\n\r\n      &:hover {\r\n        color: #ffffff;\r\n        background: var(--ca-sidebar-hover, rgba(40, 80, 173, 0.2));\r\n      }\r\n\r\n      &:focus-visible {\r\n        outline: 2px solid var(--ca-primary-light, #2850ad);\r\n        outline-offset: 2px;\r\n      }\r\n\r\n      &.active {\r\n        color: #ffffff;\r\n        background: var(--ca-sidebar-active, #0d2863);\r\n        border-color: rgba(255, 255, 255, 0.08);\r\n        font-weight: 600;\r\n      }\r\n\r\n      .entry {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.625rem;\r\n        width: 100%;\r\n        min-width: 0;\r\n        padding: 0;\r\n      }\r\n\r\n      .entry > span {\r\n        min-width: 0;\r\n        overflow-wrap: anywhere;\r\n      }\r\n\r\n      i.bi {\r\n        display: inline-flex;\r\n        flex: 0 0 1rem;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin: 0;\r\n        color: var(--ca-sidebar-icon, #7896df);\r\n        font-size: 0.9rem;\r\n      }\r\n\r\n      &:hover i.bi,\r\n      &.active i.bi {\r\n        color: #ffffff;\r\n      }\r\n    }\r\n  }\r\n\r\n  .submenu-entry {\r\n    padding-left: 0;\r\n  }\r\n\r\n  #options {\r\n    flex: 0 0 auto;\r\n    gap: 0.25rem;\r\n    margin-top: auto;\r\n    padding: 0.75rem 0.625rem 1rem;\r\n    border-top: 1px solid var(--ca-sidebar-border, rgba(255, 255, 255, 0.08));\r\n    background: var(--ca-sidebar-bg, #07112e);\r\n\r\n    > a {\r\n      min-height: 38px;\r\n    }\r\n  }\r\n}\r\n\r\n/* Keep the sidebar usable on shorter viewports. */\r\n@media (max-height: 600px) {\r\n  #sidebar {\r\n    #title {\r\n      padding-top: 1rem;\r\n      padding-bottom: 0.75rem;\r\n    }\r\n\r\n    .menu {\r\n      padding-top: 0.25rem;\r\n      padding-bottom: 0.5rem;\r\n    }\r\n\r\n    #options {\r\n      padding-top: 0.5rem;\r\n      padding-bottom: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  #sidebar,\r\n  #sidebar * {\r\n    scroll-behavior: auto !important;\r\n    transition-duration: 0.01ms !important;\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
